import { render, staticRenderFns } from "./PriceModification.vue?vue&type=template&id=4afb6d5c&"
import script from "./PriceModification.vue?vue&type=script&lang=js&"
export * from "./PriceModification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports